<div class="expander-action-row">
    <div class="expander-action-row__message">
        {{ message }}
    </div>
    <ng-content></ng-content>
</div>
